import { graphql } from '@teachino/shared-infrastructure';
import { folderFragment } from './folder.fragment';

export const renameFolderMutation = graphql(
  `
    mutation RenameFolder($id: String!, $name: String!) {
      updateLibraryFolder(updateLibraryFolderInput: { id: $id, name: $name }) {
        __typename
        libraryFolder {
          ...Folder
        }
      }
    }
  `,
  [folderFragment],
);
